import apiClient from "@/api/client";

export type PoolProtocol = "tcp" | "http";
export type PoolAlgorithm = "roundrobin" | "leastconn" | "source";
export type HealthCheckType = "tcp" | "http";

export interface LBBackend {
  id: number;
  pool_id: number;
  vm_id: number | null;
  backend_host: string;
  backend_port: number;
  weight: number;
  enabled: boolean;
  created_at: string;
}

export interface LBPool {
  id: number;
  tenant_id: number;
  name: string;
  protocol: PoolProtocol;
  listen_port: number;
  algorithm: PoolAlgorithm;
  health_check_type: HealthCheckType;
  health_check_path: string | null;
  health_check_interval_seconds: number;
  enabled: boolean;
  backends: LBBackend[];
  created_at: string;
  updated_at: string;
}

export interface LBPoolCreate {
  name: string;
  protocol: PoolProtocol;
  listen_port: number;
  algorithm?: PoolAlgorithm;
  health_check_type?: HealthCheckType;
  health_check_path?: string | null;
  health_check_interval_seconds?: number;
  enabled?: boolean;
}

export interface LBBackendCreate {
  vm_id?: number | null;
  backend_host: string;
  backend_port: number;
  weight?: number;
  enabled?: boolean;
}

export async function listPools(): Promise<LBPool[]> {
  const { data } = await apiClient.get<LBPool[]>("/lb/pools");
  return data;
}

export async function createPool(payload: LBPoolCreate): Promise<LBPool> {
  const { data } = await apiClient.post<LBPool>("/lb/pools", payload);
  return data;
}

export async function updatePool(
  id: number,
  payload: Partial<LBPoolCreate>,
): Promise<LBPool> {
  const { data } = await apiClient.patch<LBPool>(`/lb/pools/${id}`, payload);
  return data;
}

export async function deletePool(id: number): Promise<void> {
  await apiClient.delete(`/lb/pools/${id}`);
}

export async function addBackend(
  poolId: number,
  payload: LBBackendCreate,
): Promise<LBBackend> {
  const { data } = await apiClient.post<LBBackend>(
    `/lb/pools/${poolId}/backends`,
    payload,
  );
  return data;
}

export async function removeBackend(
  poolId: number,
  backendId: number,
): Promise<void> {
  await apiClient.delete(`/lb/pools/${poolId}/backends/${backendId}`);
}
